import { combineEpics } from 'redux-observable';

import { fetchPropertyContentEpic } from './epics';

export default combineEpics(fetchPropertyContentEpic);
